export interface ICreditCheckEmailResponse {
    invitationSent: boolean;
    creditCheckResult: string;
}

export class CreditCheckEmailResponse implements ICreditCheckEmailResponse {
    invitationSent: boolean;
    creditCheckResult: string;
}